import { MutableRefObject } from 'react';
import { gridColumnVisibilityModelSelector, gridSortModelSelector, gridFilterModelSelector, GridApiPro } from '@mui/x-data-grid-pro';
import { GridInitialStatePro } from '@mui/x-data-grid-pro/models/gridStatePro';

export const generateStateToRestore = (apiRef: MutableRefObject<GridApiPro>, currentState: GridInitialStatePro) => {
    const orderedFields = currentState?.columns?.orderedFields;
    const filterModel = gridFilterModelSelector(apiRef);
    const sortModel = gridSortModelSelector(apiRef);
    const visibilityModel = gridColumnVisibilityModelSelector(
        // We pass the current apiRef State but the columns from the new state we're trying to use
        {
            ...apiRef.current.state,
            columns: {
                ...apiRef.current.state.columns,
                columnVisibilityModel: currentState.columns?.columnVisibilityModel || {}
            }
        },
        apiRef.current.instanceId
    );

    const stateToRestore: GridInitialStatePro = {
        filter: { filterModel },
        sorting: { sortModel }
    };

    if (orderedFields) stateToRestore.columns = { orderedFields };

    if (visibilityModel) {
        if (stateToRestore.columns) stateToRestore.columns.columnVisibilityModel = visibilityModel;
        else stateToRestore.columns = { columnVisibilityModel: visibilityModel };
    }

    return stateToRestore;
};
